<template>
  <div class="verificacaoinventario">
      <div class="uso-item" v-bind:class="corStatusComputado">
        <b>{{ objeto.local[objeto.local.length-1].descricao }}</b><br />
        Verificado por {{objeto.local[objeto.local.length-1].responsavel}}<br />
        {{ new Date(objeto.local[objeto.local.length-1].data.seconds * 1000) | moment("DD/MM/YYYY HH:mm") }}<br />
      </div>
  </div>
</template>

<script>
export default {
  name: 'VerificacaoInventario',
  props: {
    objeto: Object,
    status: String
  },
  computed: {
    corStatusComputado: function () {
      console.log(this.status)
      return {
        blue: this.status === 'uso agendado',
        yellow: this.status === 'em uso',
        orange: this.status === 'requer verificacao',
        red: this.status === 'requer verificacao e uso agendado',
        gray: this.status === 'situacao regular'
      }
    }
  }
}
</script>

<style scoped>
a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}

.uso-item {
  color: white;
  padding: 10px;
  margin-top: 10px;
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
  border-radius:6px;
  -moz-border-radius:6px;
  -webkit-border-radius:6px;
}

.blue {
  background: rgb(26,87,213);
  background: linear-gradient(0deg, rgba(26,87,213,1) 0%, rgba(48,130,204,1) 100%);
}

.yellow {
  background: rgb(175, 139, 22);
  background: linear-gradient(0deg, rgb(175, 139, 22) 0%, rgb(199, 167, 61) 100%);
}

.lightgray {
  background: rgb(134, 134, 134);
  background: linear-gradient(0deg, rgb(134, 134, 134) 0%, rgb(146, 146, 146) 100%);
}

.gray {
  background: rgb(64, 64, 64);
  background: linear-gradient(0deg, rgb(64, 64, 64) 0%, rgb(100, 100, 100) 100%);
}

.orange {
  background: rgb(207, 124, 0);
  background: linear-gradient(0deg, rgb(207, 124, 0) 0%, rgb(209, 142, 41) 100%);
}

.red {
  background: rgb(165, 29, 29);
  background: linear-gradient(0deg, rgb(165, 29, 29) 0%, rgb(170, 56, 56) 100%);
}
</style>
